"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAddedGlobalProps = exports.GLOBAL_PROPS = void 0;
const env_1 = require("../env");
const getCookieValue_1 = __importDefault(require("./utils/getCookieValue"));
exports.GLOBAL_PROPS = {
    // Confirmed
    BEACON_ID: 'beacon',
    BEACON_ID2: 'b2',
    PAGE_VIEW_ID: 'pv_unique_id',
    PAGE_VIEW_NUMBER: 'pv_number',
    PAGE_VIEW_NUMBER_GLOBAL: 'pv_number_global',
    SESSION_ID: 'session_id',
    TIMESTAMP: 'timestamp',
    U: 'u',
    USER_ID: 'userId',
    // MW Specific
    COMMUNITY_ID: 'c',
    COMMUNITY_NAME: 'x',
    CONTENT_LANG: 'en',
    SKIN: 's',
    ARTICLE_ID: 'a', // TODO Consider changing name
};
function getDefaultsFromMWConfig(config) {
    const defaultTrackData = {};
    // Add base tracking from mw
    defaultTrackData[exports.GLOBAL_PROPS.BEACON_ID] = config.get('beaconId');
    defaultTrackData[exports.GLOBAL_PROPS.BEACON_ID2] = config.get('b2');
    defaultTrackData[exports.GLOBAL_PROPS.PAGE_VIEW_ID] = config.get('pvUID');
    defaultTrackData[exports.GLOBAL_PROPS.USER_ID] = config.get('wgUserIdForTracking') ?? -1;
    defaultTrackData[exports.GLOBAL_PROPS.U] = config.get('wgUserIdForTracking') ?? -1;
    defaultTrackData[exports.GLOBAL_PROPS.COMMUNITY_ID] = config.get('wgCityId');
    defaultTrackData[exports.GLOBAL_PROPS.COMMUNITY_NAME] = config.get('wgDBname');
    defaultTrackData[exports.GLOBAL_PROPS.CONTENT_LANG] = config.get('wgContentLanguage');
    defaultTrackData[exports.GLOBAL_PROPS.SKIN] = config.get('skin');
    defaultTrackData[exports.GLOBAL_PROPS.ARTICLE_ID] = config.get('wgArticleId');
    return defaultTrackData;
}
function getDefaultsFromFandomMWConfig(fandomConfig) {
    const defaultTrackData = {};
    defaultTrackData[exports.GLOBAL_PROPS.PAGE_VIEW_ID] = fandomConfig.pvUID;
    defaultTrackData[exports.GLOBAL_PROPS.COMMUNITY_ID] = fandomConfig.wgCityId;
    defaultTrackData[exports.GLOBAL_PROPS.SKIN] = fandomConfig.skin;
    defaultTrackData[exports.GLOBAL_PROPS.USER_ID] = fandomConfig.wgUserIdForTracking ?? -1;
    defaultTrackData[exports.GLOBAL_PROPS.U] = fandomConfig.wgUserIdForTracking ?? -1;
    return defaultTrackData;
}
function getDefaultFromFandomContextTracking(fandomContextTracking) {
    const defaultTrackData = {};
    defaultTrackData[exports.GLOBAL_PROPS.BEACON_ID] = fandomContextTracking.beaconId;
    defaultTrackData[exports.GLOBAL_PROPS.SESSION_ID] = fandomContextTracking.sessionId;
    defaultTrackData[exports.GLOBAL_PROPS.PAGE_VIEW_ID] = fandomContextTracking.pvUID;
    defaultTrackData[exports.GLOBAL_PROPS.PAGE_VIEW_NUMBER] = fandomContextTracking.pvNumber;
    defaultTrackData[exports.GLOBAL_PROPS.PAGE_VIEW_NUMBER_GLOBAL] = fandomContextTracking.pvNumberGlobal;
    return defaultTrackData;
}
function getGlobalProps() {
    if (!(0, env_1.isOnBrowser)()) {
        return {};
    }
    try {
        let defaultProps = {};
        // Add base ones consistent from any app
        defaultProps[exports.GLOBAL_PROPS.TIMESTAMP] = Date.now().toString();
        defaultProps[exports.GLOBAL_PROPS.BEACON_ID] = (0, getCookieValue_1.default)('wikia_beacon_id');
        defaultProps[exports.GLOBAL_PROPS.BEACON_ID2] = (0, getCookieValue_1.default)('_b2');
        defaultProps[exports.GLOBAL_PROPS.SESSION_ID] = (0, getCookieValue_1.default)('tracking_session_id');
        defaultProps[exports.GLOBAL_PROPS.PAGE_VIEW_NUMBER] = (0, getCookieValue_1.default)(exports.GLOBAL_PROPS.PAGE_VIEW_NUMBER);
        defaultProps[exports.GLOBAL_PROPS.PAGE_VIEW_NUMBER_GLOBAL] = (0, getCookieValue_1.default)(exports.GLOBAL_PROPS.PAGE_VIEW_NUMBER_GLOBAL);
        // If we are on MW lets add them this way
        if (window && 'mw' in window && window.mw.config) {
            defaultProps = { ...defaultProps, ...getDefaultsFromMWConfig(window.mw.config) };
        }
        else if (window && 'fandomMWConfig' in window) {
            // If we are not on MW but fandomMWConfig is initialised
            defaultProps = { ...defaultProps, ...getDefaultsFromFandomMWConfig(window.fandomMWConfig) };
        }
        if (window && 'fandomContext' in window && window.fandomContext?.tracking) {
            defaultProps = { ...defaultProps, ...getDefaultFromFandomContextTracking(window.fandomContext.tracking) };
        }
        return defaultProps;
    }
    catch (e) {
        console.error('Failed to add global props', e);
        return {};
    }
}
exports.default = getGlobalProps;
function withAddedGlobalProps(trackData) {
    return {
        ...getGlobalProps(),
        ...trackData,
    };
}
exports.withAddedGlobalProps = withAddedGlobalProps;
